var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserFrameGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 707.357,
    height: 650.186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style13081"
  }, ".st2{fill:#fff9c7}.st12,.st7{opacity:.5;fill:#fff}.st12{fill:#be2f55}.st13{fill:#ffab34}.st14{fill:#ffd134}.st15{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "g13398",
    transform: "translate(-101.616 -105.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13135"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 900.95,
    y1: 605.323,
    x2: 900.95,
    y2: -66.484,
    gradientTransform: "rotate(-41.721 636.338 1105.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc800"
    },
    id: "stop13083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    style: {
      stopColor: "#ffa200"
    },
    id: "stop13085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    style: {
      stopColor: "#ef8d00"
    },
    id: "stop13087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#d36600"
    },
    id: "stop13089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#bc4600"
    },
    id: "stop13091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    style: {
      stopColor: "#aa2d00"
    },
    id: "stop13093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    style: {
      stopColor: "#9d1b00"
    },
    id: "stop13095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#951000"
    },
    id: "stop13097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#930d00"
    },
    id: "stop13099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 900.816,
    y1: 527.488,
    x2: 900.816,
    y2: -67.326,
    gradientTransform: "rotate(-41.721 636.338 1105.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cc4300"
    },
    id: "stop13104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    style: {
      stopColor: "#c94100"
    },
    id: "stop13106"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    style: {
      stopColor: "#c03b00"
    },
    id: "stop13108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#b13100"
    },
    id: "stop13110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#9c2200"
    },
    id: "stop13112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#8d1800"
    },
    id: "stop13114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    style: {
      stopColor: "#911d00"
    },
    id: "stop13116"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#9d2b00"
    },
    id: "stop13118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    style: {
      stopColor: "#b04200"
    },
    id: "stop13120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    style: {
      stopColor: "#cb6300"
    },
    id: "stop13122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#ed8c00"
    },
    id: "stop13124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    style: {
      stopColor: "#ffa200"
    },
    id: "stop13126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc200"
    },
    id: "stop13128"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g13249"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.633,
    y1: 667.325,
    x2: 428.633,
    y2: 105.47,
    gradientTransform: "matrix(-1 0 0 1 882 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#930d00"
    },
    id: "stop13191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    style: {
      stopColor: "#951000"
    },
    id: "stop13193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    style: {
      stopColor: "#9d1b00"
    },
    id: "stop13195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    style: {
      stopColor: "#aa2d00"
    },
    id: "stop13197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    style: {
      stopColor: "#bc4600"
    },
    id: "stop13199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    style: {
      stopColor: "#d36600"
    },
    id: "stop13201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    style: {
      stopColor: "#ef8d00"
    },
    id: "stop13203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    style: {
      stopColor: "#ffa200"
    },
    id: "stop13205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc800"
    },
    id: "stop13207"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.44 386.43c0 155.11 125.78 280.89 280.89 280.89 155.18 0 280.96-125.78 280.96-280.89 0-155.18-125.78-280.96-280.96-280.96-155.11 0-280.89 125.78-280.89 280.96zm33.12 0c0-136.87 110.97-247.84 247.77-247.84 136.87 0 247.84 110.97 247.84 247.84S590.2 634.2 453.33 634.2c-136.8 0-247.77-110.9-247.77-247.77z",
    id: "path13210",
    style: {
      fill: "url(#SVGID_5_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.67,
    y1: 659.226,
    x2: 428.67,
    y2: 113.641,
    gradientTransform: "matrix(-1 0 0 1 882 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cc4300"
    },
    id: "stop13212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    style: {
      stopColor: "#c94100"
    },
    id: "stop13214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    style: {
      stopColor: "#c03b00"
    },
    id: "stop13216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#b13100"
    },
    id: "stop13218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#9c2200"
    },
    id: "stop13220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#8d1800"
    },
    id: "stop13222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    style: {
      stopColor: "#911d00"
    },
    id: "stop13224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    style: {
      stopColor: "#9d2b00"
    },
    id: "stop13226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    style: {
      stopColor: "#b04200"
    },
    id: "stop13228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    style: {
      stopColor: "#cb6300"
    },
    id: "stop13230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    style: {
      stopColor: "#ed8c00"
    },
    id: "stop13232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    style: {
      stopColor: "#ffa200"
    },
    id: "stop13234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc200"
    },
    id: "stop13236"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.54 386.43c0 150.66 122.13 272.79 272.79 272.79 150.66 0 272.79-122.13 272.79-272.79 0-150.66-122.13-272.79-272.79-272.79-150.66 0-272.79 122.13-272.79 272.79zm25.02 0c0-136.87 110.97-247.84 247.77-247.84 136.87 0 247.84 110.97 247.84 247.84S590.2 634.2 453.33 634.2c-136.8 0-247.77-110.9-247.77-247.77z",
    id: "path13239",
    style: {
      fill: "url(#SVGID_6_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M639.86 191.54c4.03 15.24-3.92 22.04-26.24-2.59-33.07-36.49-75.86-53.73-169.85-54.31-93.99-.58-156.37 51.46-185.48 94.58-29.11 43.11-22.5 17.45-18.22 6.49 3.11-7.97 32.68-122.06 198.95-122.06 166.27 0 198.75 69.98 200.84 77.89z",
    id: "path13241"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M660.84 563.47s-80.55 84.68-207.48 84.68c-126.93 0-207.51-84.68-207.51-84.68s73.08 95.74 207.51 95.74 207.48-95.74 207.48-95.74z",
    id: "path13243",
    style: {
      opacity: 0.8,
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M574.19 151.34c11.36 24.31-49.57-6.25-69.64-12.89-19.08-6.32 55.1-18.23 69.64 12.89z",
    id: "path13247"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g13302"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.758,
    y1: 615.881,
    x2: 673.758,
    y2: 267.489,
    gradientTransform: "matrix(-1 0 0 1 882 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ac3b00"
    },
    id: "stop13251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa900"
    },
    id: "stop13253"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.11 381.44c13.37 69.8 80.38 150.47 150.02 200.04 20.5 14.52 41.19 26.39 60.73 34.4-3.67-4.17-117.48-134.89-151.9-232.46-34.03-96.76 3.79-106.12 2.02-114.62-.96-4.68-24.54 3.06-42.52 25.68l-.14.07c-14.74 18.43-25.88 46.87-18.21 86.89z",
    id: "path13256",
    style: {
      fill: "url(#SVGID_7_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 680.23,
    y1: 438.458,
    x2: 680.23,
    y2: 132.227,
    gradientTransform: "matrix(-1 0 0 1 882 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ac3b00"
    },
    id: "stop13258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa900"
    },
    id: "stop13260"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.86 404.77c0 .07 0 .15.07.22 6.41 19.38 12.21 31.8 13.03 33.46-16.45-56.45-14.63-148.25 27.97-174.43 0 0 27.55-99.52 31.24-125.23.4-3.13.52-5.19.15-5.83-4.16-7.1-98.26 37.23-106.9 139.35-4.26 50.24 24.22 101.57 34.44 132.46z",
    id: "path13263",
    style: {
      fill: "url(#SVGID_8_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 598.423,
    y1: 750.71,
    x2: 598.423,
    y2: 432.338,
    gradientTransform: "matrix(-1 0 0 1 882 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ac3b00"
    },
    id: "stop13265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa900"
    },
    id: "stop13267"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.24 571.11c12.18 48.61 191.33 63.79 245.71 96.99 44.79 27.35 38.63 40.66 30.37 45.51-1.95 1.12-3.98 1.76-5.55 2.03-7.92 1.38 6.15-20.49-17.64-26.23-23.54-5.62-24.51 20.53-17.94 29.06 0 0 20.86 33.44 54.12 32.21 27.61-1.07 37.97-67.17 27.33-104.48v-.08c-2.19-7.85-5.37-14.42-9.52-18.85-23.46-25.15-125.89 4.56-207.29-68.56-78.8-70.76-99.06-115.77-103.18-125.69-1.37-3.35-2.8 5.89-3.64 21.34v.15c-1.47 30.35-.67 84.79 7.23 116.6z",
    id: "path13270",
    style: {
      fill: "url(#SVGID_9_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M127.24 571.11c12.18 48.61 191.33 63.79 245.71 96.99 44.79 27.35 38.63 40.66 30.37 45.51 0 0 34.16-32.75 15.86-77.22-18.09-43.98-106.96.03-206.02-39.66-75.87-30.5-90.35-110.13-93.14-142.23-1.48 30.36-.68 84.8 7.22 116.61z",
    id: "path13272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M362.19 718.47s20.86 33.44 54.12 32.21c27.61-1.07 37.97-67.17 27.33-104.48.08 3.16 1.24 76.35-28.42 89.35-30.12 13.2-45.28-23.97-46-32.46-.65-8.54 10.9-13.68 10.9-13.68-23.54-5.62-24.5 20.53-17.93 29.06z",
    id: "path13274"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M104.11 381.44c13.37 69.8 80.38 150.47 150.02 200.04 14.74 7.9 26.7 13.29 32.86 13.97 0 0-120.91-111.99-152.96-183.47-31.43-70.17-11.56-117.51-11.56-117.51l-.14.07c-14.75 18.44-25.89 46.88-18.22 86.9z",
    id: "path13276"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M182.86 404.77c0 .07 0 .15.07.22 6.41 19.38 12.21 31.8 13.03 33.46-16.45-56.45-14.63-148.25 27.97-174.43 0 0 27.55-99.52 31.24-125.23l-1.09-.14s-46.13 35.04-63.5 91.36c-17.43 56.63-15.08 137.46-7.72 174.76z",
    id: "path13278"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M203.78 465.45s-43.45 3.49-61.14-36.8c-17.5-39.85-29.75-84.74-19.66-111.76 10.08-26.98 25.06-21.85 25.06-21.85s-7.49 12.74 6.99 62.8c14.65 50.64 48.75 107.61 48.75 107.61z",
    id: "path13280"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M291.39 597.1s-72.1 20.24-114-21.41c-41.19-40.95-42.31-100.91-38.62-104.55 3.69-3.64 11.95 13.51 64.19 65.24 53.39 52.87 88.43 60.72 88.43 60.72z",
    id: "path13282"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M238.97 152.3s-47.99 39.37-56.06 110.87c-8.14 72.17-30.19 12.7-29.35-20.41.84-32.94 43.63-80.03 85.41-90.46z",
    id: "path13284"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M341.25 615.02s-94.57 1.67-151.54-38.6c-55.8-39.44-67.31-103.54-67.31-103.54s2.65 83.49 76.76 118.26c66.19 31.06 142.09 23.88 142.09 23.88z",
    id: "path13286"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M221.3 529.22s-80.1-94.14-92.16-136.02c-11.94-41.47-12.53-68.73-12.53-68.73s-26.9 79.4 104.69 204.75z",
    id: "path13288"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M238.97 152.3s-62.99 52.39-61.39 198.98c-.01 0-20.07-131.7 61.39-198.98z",
    id: "path13290"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M443.28 662.06c-4.09 32.4-16.38-24.07-30.43-35.24-13.98-11.12 30.54-18.91 30.43 35.24z",
    id: "path13292"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M404.21 623.27c14.03 7.28 24.74 41.19 14.08 58.21-10.66 17.02-26.43-13.78-97.51-35.28-69.6-21.04 43.08-43.87 83.43-22.93z",
    id: "path13294"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.41 353.68c9.31-29.62 14.93 33.34 11.73 39.52-3.21 6.17-16.66-23.84-11.73-39.52z",
    id: "path13296"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.65 161.69c9.59-2.43-14.16 53.78-25.12 60.89-10.94 7.1-18.58-49.82 25.12-60.89z",
    id: "path13298"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M424.25 728.85c6.41-18.23-25.18-4.42-38.82-10.63-13.59-6.18.13 20.8 18.46 20.09 18.42-.71 20.36-9.46 20.36-9.46z",
    id: "path13300"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g13382"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 566.621,
    y1: 614.86,
    x2: 566.621,
    y2: 264.078,
    gradientTransform: "translate(132.939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ac3b00"
    },
    id: "stop13331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa900"
    },
    id: "stop13333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M806.46 376.48c-13.55 69.77-81.88 151.57-153.48 202.59-21.19 15.03-42.6 27.38-62.83 35.79 3.83-4.31 121.56-138.18 156.91-236.13 34.51-95.9-3.43-105-1.62-113.37.98-4.6 24.62 2.94 42.61 25.13l.14.07c14.8 18.13 25.99 46.19 18.27 85.92z",
    id: "path13336",
    style: {
      fill: "url(#SVGID_11_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 576.075,
    y1: 433.913,
    x2: 576.075,
    y2: 132.228,
    gradientTransform: "translate(132.939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ac3b00"
    },
    id: "stop13338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa900"
    },
    id: "stop13340"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M726.85 400.13c0 .07 0 .15-.08.22-6.59 19.42-12.55 31.89-13.39 33.56 16.96-56.51 15.55-147.44-27.15-173.09 0 0-26.87-97.27-30.34-122.24-.37-3.03-.47-5.03-.09-5.65 4.22-6.87 97.91 36.08 106.25 135.84 4.15 49.5-24.72 100.51-35.2 131.36z",
    id: "path13343",
    style: {
      fill: "url(#SVGID_12_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 488.25,
    y1: 755.649,
    x2: 488.25,
    y2: 427.343,
    gradientTransform: "translate(132.939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ac3b00"
    },
    id: "stop13345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffa900"
    },
    id: "stop13347"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M782.85 567.36c-12.53 49.69-196.77 67.08-253.5 101.91-46.99 28.85-40.84 42.61-32.34 47.55 2 1.14 4.11 1.78 5.74 2.05 8.22 1.34-6.01-21.22 18.79-27.45 24.51-6.1 25.1 21.02 18.14 29.96 0 0-22.26 35.12-56.92 34.26-28.8-.76-38.18-69.49-26.34-108.23v-.08c2.44-8.13 5.87-14.94 10.27-19.54 24.78-26.1 130.08 3.4 214.44-72.16C761.84 483.36 782.49 438 786.67 428.04c1.39-3.36 2.82 5.88 3.66 21.36v.15c1.48 30.47.62 85.45-7.48 117.81z",
    id: "path13350",
    style: {
      fill: "url(#SVGID_13_)"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M782.85 567.36c-12.53 49.69-196.77 67.08-253.5 101.91-46.99 28.85-40.84 42.61-32.34 47.55 0 0-34.89-33.61-15-79.79 19.54-45.4 110.6-1.08 212.87-42.75 77.73-31.78 92.6-112.46 95.46-144.73 1.47 30.47.61 85.45-7.49 117.81z",
    id: "path13352"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M539.7 721.38s-22.26 35.12-56.92 34.26c-28.8-.76-38.18-69.49-26.34-108.23-.15 3.26-2.89 79.23 27.76 92.42 31.14 13.39 47.55-25.52 48.44-34.34.81-8.87-11.09-14.06-11.09-14.06 24.51-6.11 25.1 21 18.15 29.95z",
    id: "path13354"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M806.46 376.48c-13.55 69.77-81.88 151.57-153.48 202.59-15.2 8.21-27.55 13.83-33.89 14.59 0 0 124.44-114.7 157.13-186.59 31.75-69.91 11.83-116.56 11.83-116.56l.14.07c14.8 18.11 25.99 46.17 18.27 85.9z",
    id: "path13356"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M726.85 400.13c0 .07 0 .15-.08.22-6.59 19.42-12.55 31.89-13.39 33.56 16.96-56.51 15.55-147.44-27.15-173.09 0 0-26.87-97.27-30.34-122.24l1.09-.14s45.87 34.01 62.94 88.94c17.26 55.56 14.54 135.55 6.93 172.75z",
    id: "path13358"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M705.3 461.07s44.13 3.22 62.19-37.31c17.76-39.87 30.15-84.49 20.03-111.17-10.08-26.56-25.13-21.47-25.13-21.47s7.49 12.53-7.22 62.13c-14.99 50.52-49.87 107.82-49.87 107.82z",
    id: "path13360"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M614.55 595.38s73.9 20.03 117.07-22.92c42.17-41.94 43.42-102.47 39.69-106.1-3.74-3.63-12.17 13.68-65.61 66.37-55.07 54.29-91.15 62.65-91.15 62.65z",
    id: "path13362"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M672 151.69s47.74 38.26 55.48 108.2c7.87 71.15 30.26 12.4 29.51-20.09-.74-32.2-43.31-77.99-84.99-88.11z",
    id: "path13364"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M562.96 614.23s97.36.77 156.06-40.92c57.1-40.55 68.88-105.32 68.88-105.32s-2.8 84.36-78.65 120.43c-68.18 32.43-146.29 25.81-146.29 25.81z",
    id: "path13366"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M687.02 525.61s81.91-95.42 94.18-137.31c12.09-41.26 12.71-68.23 12.71-68.23s27.07 78.65-106.89 205.54z",
    id: "path13368"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M672 151.69s62.69 50.93 60.45 195.16c-.01.01 20.65-129.72-60.45-195.16z",
    id: "path13370"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M456.49 663.8c3.58 33.54 17.49-25.04 32.26-36.7 14.67-11.59-31.25-19.16-32.26 36.7z",
    id: "path13372"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M497.76 623.35c-14.66 7.64-26.44 42.77-15.71 60.28 10.75 17.54 27.7-14.57 101.59-37.53 71.98-22.36-43.82-44.67-85.88-22.75z",
    id: "path13374"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M793.08 348.98c-9.34-29.27-15.1 33.19-11.87 39.32 3.22 6.14 16.82-23.79 11.87-39.32z",
    id: "path13376"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M695.24 160.8c-9.57-2.35 13.84 52.38 24.79 59.32 10.93 6.93 18.81-48.59-24.79-59.32z",
    id: "path13378"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M474.93 732.95c-6.31-18.91 26.31-4.92 40.62-11.55 14.23-6.6-.49 21.67-19.58 21.16-19.2-.51-21.04-9.61-21.04-9.61z",
    id: "path13380"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 516.381,
    cy: 642.684,
    r: 51.274,
    gradientTransform: "matrix(.1873 .6983 .3544 -.095 -197.439 70.377)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop13384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop13386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 499.018,
    cy: 2309.464,
    r: 51.275,
    gradientTransform: "matrix(.1873 .6983 .3544 -.095 -197.439 70.377)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop13391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop13393"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFrameGold);
export default __webpack_public_path__ + "static/media/user_frame_gold.87689e2338458d02d2a15ea94196a72f.svg";
export { ForwardRef as ReactComponent };